module.exports = __webpack_public_path__ + "img/21.9dc8d9db.jpg";